import React from 'react'
import { MegaMenuItem } from '@/components/molecules/MegaMenuItem/MegaMenuItem'

export function Features({ menu }: { menu: MegaMenu }) {
  return (
    <div key={menu._uid} className="bg-grey-50 p-24 netbook:p-24 lg:p-40 row-span-2">
      <p className="text-bodyS text-text-dark-900 font-bold capitalize mb-16 netbook:mb-8">{menu.text}</p>
      <ul className="grid netbook:grid-cols-1 gap-16 netbook:my-24">
        {menu.dropdown_menu?.map((item) => <MegaMenuItem key={item._uid} item={item} variant="features" />)}
      </ul>
    </div>
  )
}
